/* eslint-disable no-underscore-dangle */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  IBulkIssueSessionCertificatePayload,
  IExportSessionCertificatesPayload,
  IGenerateSession,
  IGetSessionCertificatesPayload,
  IIssueSessionCertificatePayload,
  ISession,
  ISessionCertificatesResponse,
  ISessionDelete,
  ISessionSummeryUpdate,
  ISupport,
  SessionSummaryState,
} from './interface';

const frequency = {
  startAt: '',
  endAt: '',
  startDate: '',
  endDate: '',
  dayOfTheMonth: '',
  dayOfTheWeek: '',
  frequency: 'One time',
};

const waitingRoomMedia = {
  fileName: '',
  thumbnailUrl: '',
  contentUrl: '',
  fileType: '',
};

const badge = {
  badgeTitle: '',
  badgeDescription: '',
  badgeImgUrl: '',
};

export const initialState: SessionSummaryState = {
  loading: false,
  actionLoading: false,
  certificatesStateLoading: false,
  certificatesRefetchTrigger: false,
  certificatesExportSuccessTrigger: false,
  issuingCertificateUserId: '',
  bulkIssuingCertificatesLoading: false,
  exportingCertificatesLoading: false,
  session: {
    id: '',
    isActive: false,
    sessionType: '',
    audienceType: '',
    title: '',
    description: '',
    numberOfSessions: 0,
    waitingRoomMedia,
    numberOfParticipants: 0,
    isObserverAllowed: false,
    numberOfObservers: 0,
    availableTimes: [],
    frequency,
    fee: '0',
    discount: '0',
    currency: 'USD',
    subscriberFee: '0',
    subscriberCurrency: 'USD',
    subscriberDiscount: '0',
    observerFee: '0',
    observerDiscount: '0',
    observerCurrency: 'USD',
    subscribeObserverFee: '0',
    subscribeObserverCurrency: 'USD',
    subscribeObserverDiscount: '0',
    forms: [],
    media: [],
    language: 'English',
    summary: [],
    updates: [],
    modules: [],
    badge,
    certificateIssuance: false,
    certificate: undefined,
    statistics: {
      allTimeSessionPurchased: 0,
      weeklyTimeSessionPurchased: 0,
      userEnrolled: 0,
      completed: 0,
    },
    purchaseHistory: [],
    bookedSessions: 0,
    bookedObservers: 0,
    availableSessions: 0,
    availableParticipants: 0,
    availableObservers: 0,
    deleted: false,
    deletedAt: '',
    highlightMedia: {
      _id: '',
      title: '',
      contentUrl: '',
      fileType: '',
      fileCategory: 'image',
      thumbnail: '',
      fileSize: 0,
    },
  },
  sessionCertificates: {
    result: [],
    total: 0,
  },
  sessionUrl: '',
};

export const sessionSummarySlice = createSlice({
  name: 'feature/session/summary',
  initialState,
  reducers: {
    fetchSessionSummary(state: SessionSummaryState, action: PayloadAction<string>) {
      state.loading = true;
    },
    fetchSessionSummarySucceeded(state: SessionSummaryState, action: PayloadAction<ISession>) {
      state.loading = false;
      state.session = action.payload;
    },
    fetchSessionSummaryFailed(state: SessionSummaryState) {
      state.loading = false;
    },
    getSessionCertificates(
      state: SessionSummaryState,
      action: PayloadAction<IGetSessionCertificatesPayload>,
    ) {
      state.certificatesStateLoading = true;
    },
    getSessionCertificatesSucceeded(
      state: SessionSummaryState,
      action: PayloadAction<ISessionCertificatesResponse>,
    ) {
      state.sessionCertificates = action.payload;
      state.certificatesStateLoading = false;
    },
    getSessionCertificatesFailed(state: SessionSummaryState) {
      state.certificatesStateLoading = false;
    },
    exportSessionCertificates(
      state: SessionSummaryState,
      action: PayloadAction<IExportSessionCertificatesPayload>,
    ) {
      state.exportingCertificatesLoading = true;
    },
    exportSessionCertificatesSucceeded(state: SessionSummaryState) {
      state.exportingCertificatesLoading = false;
      state.certificatesExportSuccessTrigger = !state.certificatesExportSuccessTrigger;
    },
    exportSessionCertificatesFailed(state: SessionSummaryState) {
      state.exportingCertificatesLoading = false;
    },
    getSessionUrl(state: SessionSummaryState, action: PayloadAction<IGenerateSession>) {
      state.loading = true;
    },
    getSessionUrlSuccessed(state: SessionSummaryState, action: PayloadAction<string>) {
      state.loading = false;
      state.sessionUrl = action.payload;
    },
    getSessionUrlFailed(state: SessionSummaryState) {
      state.loading = false;
    },
    clearSessionUrl(state: SessionSummaryState) {
      state.sessionUrl = '';
    },
    updateSessionSummery(state: SessionSummaryState, action: PayloadAction<ISessionSummeryUpdate>) {
      state.loading = true;
      if (typeof action.payload?.isActive !== 'undefined') {
        state.session.isActive = action.payload.isActive;
      }
      if (action.payload?.invitePeople) {
        state.session.invitePeople = action.payload.invitePeople;
      }
    },
    updateSessionSummerySucceeded(state: SessionSummaryState) {
      state.loading = false;
    },
    updateSessionSummeryFailed(state: SessionSummaryState) {
      state.loading = false;
    },
    deleteSession(state: SessionSummaryState, action: PayloadAction<ISessionDelete>) {
      state.actionLoading = true;
    },
    deleteSessionSucceeded(state: SessionSummaryState) {
      state.actionLoading = false;
    },
    deleteSessionFailed(state: SessionSummaryState) {
      state.actionLoading = false;
    },
    createSupportFeedback(state: SessionSummaryState, action: PayloadAction<ISupport>) {
      state.loading = true;
    },
    createSupportFeedbackSucceeded(state: SessionSummaryState, action: PayloadAction<ISupport>) {
      state.loading = false;
    },
    createSupportFeedbackFailed(state: SessionSummaryState) {
      state.loading = false;
    },
    issueSessionCertificate(
      state: SessionSummaryState,
      action: PayloadAction<IIssueSessionCertificatePayload>,
    ) {
      state.issuingCertificateUserId = action.payload.userId;
    },
    issueSessionCertificateSucceeded(state: SessionSummaryState) {
      state.issuingCertificateUserId = '';
    },
    issueSessionCertificateFailed(state: SessionSummaryState) {
      state.issuingCertificateUserId = '';
    },
    bulkIssueSessionCertificate(
      state: SessionSummaryState,
      action: PayloadAction<IBulkIssueSessionCertificatePayload>,
    ) {
      state.bulkIssuingCertificatesLoading = true;
    },
    bulkIssueSessionCertificateSucceeded(state: SessionSummaryState) {
      state.bulkIssuingCertificatesLoading = false;
    },
    bulkIssueSessionCertificateFailed(state: SessionSummaryState) {
      state.bulkIssuingCertificatesLoading = false;
    },
    triggerRefetchSessionCertificates(state: SessionSummaryState) {
      state.certificatesRefetchTrigger = !state.certificatesRefetchTrigger;
    },
    reset: () => initialState,
  },
});

export const { actions: sessionSummaryActions } = sessionSummarySlice;
